var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-nav",class:_vm.getAppClass,attrs:{"id":"app"}},[_c('router-view'),_c('notification-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }